// Func = limiting Scope for this file
var lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {

	let business_specials__filter = [...document.querySelectorAll( ".business_specials__filter [type=checkbox]" )]
	let business_specials__columns_articles = [...document.querySelectorAll( ".business_specials__columns article" )]
	
	business_specials__filter.forEach( ( item ) => {

		let values = []
		let all = false;

		item.addEventListener( "change", ( e ) => {
			values = []
			all = false
			business_specials__filter.forEach( ( c ) => {

				if( c.checked ){
					values.push( c.id )

					if( c.id == "all" )
						all = true
				}
			} )

			if( values.length == 0 )
				all = true

			business_specials__columns_articles.forEach( item => {
				item.classList.add( "hidden" )
				values.forEach( value => {
					if( item.classList.contains( value ) || all )
						item.classList.remove( "hidden" )
				} )
				if(all)
					item.classList.remove("hidden")
			} )
		} )

	} )

	// Banner in meeting page	
		const observer = new MutationObserver(() => {
		const bodyElement = document.querySelector('body'); 
		const targetElement = document.querySelector('.top-content-meetings__ctas');

		if (bodyElement.hasAttribute('style') && targetElement) {
			targetElement.classList.add('has-banner');
		
			observer.disconnect();
		}
	});
	const langElement = document.querySelector('.header__lang-active');
	if (langElement) {
		langElement.addEventListener('click', function(e) {
			e.preventDefault();
			document.querySelector('.header__lang-select').classList.toggle('open');
		});
	}

	observer.observe(document.body, { childList: true, subtree: true });

	let js_cat_278 = document.querySelector( ".js-cat_278" )
	if( js_cat_278 ){
		js_cat_278.addEventListener( "click", e => {
			let parent_278 = document.querySelector( ".parent_278" )
			parent_278.classList.toggle( "hidden" )
		} )
	}

	setTimeout( () => {
		let boating_boat_yacht_clubs = [...document.querySelectorAll( ".boating.boat-yacht-clubs .columns-tabs__container article" )]
		if( boating_boat_yacht_clubs ){
			boating_boat_yacht_clubs.forEach( item => {
				let links = [...item.querySelectorAll( "a" )]
				links.forEach( ( link ) => {
					link.setAttribute( "data-name", item.querySelector( ".columns-tabs__title" ).innerText )
				} )
			} )
		}

		let tabs_info__content = [...document.querySelectorAll( ".harbor-rules-regulations .tabs-info__tabs li" )]
		if( tabs_info__content ){
			tabs_info__content.forEach( item => {
				item.addEventListener( "click", (e) => {
					let title = e.target.innerText 

					setTimeout( () => {
						let links = [...item.parentNode.parentNode.parentNode.querySelectorAll( ".tabs-info__content .tabs-info__item.active a" )]
						console.log( links )
						if(links){
							links.forEach( link => link.setAttribute( "data-name", title ) )
						}
					}, 200 )
						
				} )
			} )
			if(tabs_info__content[0]){
				tabs_info__content[0].click()
			}
		}

	}, 1500 )

	let sighsseeing_tour__item = document.querySelectorAll( ".sighsseeing-tour__item" )
	if( sighsseeing_tour__item ){
		sighsseeing_tour__item.forEach( item => {
			let links = item.querySelectorAll( "a" )
			let title = item.querySelector( "h2" ).innerText

			links.forEach( link => {
				link.setAttribute( "data-name", title )
			} )

		} )
	}

	if (document.querySelector("#top-content video") != null) {
		document.querySelector("#header").classList.add("video-header");
	}

	//Api Weather
	if (document.querySelector('[data-weather-widget]')) {
		ApiWeather()
	}

	//Burger Menu
	const burgerBtns = document.querySelectorAll('[data-ctaburger]')
	const burgerContent = document.querySelector('[data-menuburger]')

	burgerBtns.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault()
			burgerContent.classList.toggle('open')
			document.body.classList.toggle('no-scroll')
		})
	})

	//Booking Cta
	const bookingBtns = document.querySelectorAll('[data-bookingcta]')
	const bookingContent = document.querySelector('#booking-engine')

	bookingBtns.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault()
			bookingContent.classList.toggle('open')
			document.body.classList.toggle('no-scroll')
		})
	})

	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll('[data-menuburger] .burger-menu__nav li:has(.submenu)')

		let prevMenuItem

		menu_Items.forEach((element) => {
			// active for link generate in js
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			const newListItem = `
			<li class="primary-nav-js">
				<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">overview</a>
			</li>`

			Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			// active for link generate in js
			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}

			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
					prevMenuItem.classList.remove('active')
				e.target.nextElementSibling.classList.toggle('active')
				prevMenuItem = e.target.nextElementSibling
			})
		})
	}

	//Top Content validation
	const Specialsubtitle = document.querySelector('#default:not(.page-1722) .top-content-quad__subtitle:has(em)')
	if (Specialsubtitle) {
		Specialsubtitle.previousElementSibling.classList.add('special-subtitle')
	}

	//Special Texture for Group
	const texture_Group = document.querySelector('.group-start.special-texture')
	console.log("🚀 ~ texture_Group:", texture_Group)
	const texture_Group2 = document.querySelector('.group-start.special-texture2')
	console.log("🚀 ~ texture_Group2:", texture_Group2)

	if (texture_Group) {
		texture_Group.classList.add('animate-fade')
		const customSVG =
			'<div class="group-texture"><svg xmlns="http://www.w3.org/2000/svg"  width="1920" height="255.25" viewBox="0 0 1920 175.25"><defs><style>.cls-12{fill:#102C3C;stroke-width:0px;}</style></defs><path class="cls-12" d="M1876.73,49.49C1754.33,15.25,1582.3-.36,1477.65,0s-261.45,14.69-417.86,53.4c-156.41,38.71-281.04,64.74-455.37,81.17C432.57,150.79,141.46,125.48,0,80.98v92.96l1920,1.32V62.08c-14.46-4.17-28.76-8.28-43.27-12.59Z"/></svg><svg xmlns="http://www.w3.org/2000/svg" width="1920.98" height="200" viewBox="0 0 1920.98 160"><defs><style>.cls-1{fill:none;stroke:transparent;stroke-miterlimit:10;}</style></defs><path id="lineAC" class="cls-1" d="M.14,102.08s442.36,129.2,939.49,0l137.98-31.06s187.71-49.16,396.27-49.16c259.22-4.47,446.93,61.08,446.93,61.08"/><text><textPath href="#lineAC">· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s</textPath></text></svg></div>'
		texture_Group.insertAdjacentHTML('afterbegin', customSVG)
	}
	if (texture_Group2) {
		texture_Group2.classList.add('animate-fade')
		const customSVG =
			'<div class="group-texture"><svg xmlns="http://www.w3.org/2000/svg"  width="1920" height="255.25" viewBox="0 0 1920 175.25"><defs><style>.cls-12{fill:#FFF6EF;stroke-width:0px;}</style></defs><path class="cls-12" d="M1876.73,49.49C1754.33,15.25,1582.3-.36,1477.65,0s-261.45,14.69-417.86,53.4c-156.41,38.71-281.04,64.74-455.37,81.17C432.57,150.79,141.46,125.48,0,80.98v92.96l1920,1.32V62.08c-14.46-4.17-28.76-8.28-43.27-12.59Z"/></svg><svg xmlns="http://www.w3.org/2000/svg" width="1920.98" height="200" viewBox="0 0 1920.98 160"><defs><style>.cls-1{fill:none;stroke:transparent;stroke-miterlimit:10;}</style></defs><path id="lineAC" class="cls-1" d="M.14,102.08s442.36,129.2,939.49,0l137.98-31.06s187.71-49.16,396.27-49.16c259.22-4.47,446.93,61.08,446.93,61.08"/><text><textPath href="#lineAC">· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s· Marina del Rey · l.a.’s</textPath></text></svg></div>'
		texture_Group2.insertAdjacentHTML('afterbegin', customSVG)
	}
	

	// CTA functionality
	const allCtas = document.querySelectorAll('.btn, .signup-btn , .btn-business')
	allCtas.forEach((Cta) => {
		const textCta = Cta.textContent
		Cta.innerHTML = `<span class="label-cta">${textCta}</span>`
	})

	const allCtasAlter = document.querySelectorAll('.btn-alt')
	allCtasAlter.forEach((Cta) => {
		const textCta = Cta.textContent
		Cta.innerHTML = `<span class="link-middle">${textCta}</span>`
	})

	const specailCtaBusinnes = document.querySelector('button#btn-continue')
	if (specailCtaBusinnes) {
		specailCtaBusinnes.addEventListener('click', function (e) {
			console.log(e)
			setTimeout(() => {
				const textCta = e.target.textContent
				e.target.innerHTML = `<span class="label-cta">${textCta}</span>`
			}, 500)
		})
	}

	const ctaBusinnesLightbox = document.querySelectorAll('.fancybox')
	if (ctaBusinnesLightbox) {
		ctaBusinnesLightbox.forEach((element) => {
			element.setAttribute("data-lbx","")
		})
	}
	
function isSafari() {
		var ua = navigator.userAgent.toLowerCase(); 
		return ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1 && ua.indexOf('android') == -1;
}

// SPLIT CURSIVE TITLE TEXT
document.querySelectorAll('h2 em, .h2 em').forEach((span) => {
		span.classList.add('char-wrapper')
		const chars = span.textContent
				.trim()
				.split('')
				.map((char) => `<span class="char">${char}</span>`)
				.join('')
		span.innerHTML = chars
})

// Add 'is-safari' class if the browser is Safari
if (isSafari()) {
	
		if (document.querySelector(".top-content__video") != null) {
			document.querySelector(".top-content__video").play();
		}

		document.querySelectorAll('h2 em .char, .h2 em .char,h2 em, .h2 em').forEach((element) => {
				element.classList.add('is-safari');
		});
		
}

	// Privary navigation submenu
	let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item')

	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			;['mouseenter', 'mouseleave'].forEach((event) => {
				itemMenu.addEventListener(event, () => {
					itemMenu.classList.toggle('hover')
					itemMenu.querySelector('.submenu').classList.toggle('show')
				})
			})
		}
	})

	// header scroll functionality
	window.addEventListener('load', scrollW)
	window.addEventListener('scroll', scrollW)

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	//Class Group next and previous section
	const allTextGroup = document.querySelectorAll('.group-start')
	if (allTextGroup) {
		allTextGroup.forEach((element) => {
			document.querySelector('main').classList.add('hasgroup')
			element.previousElementSibling.classList.add('group-before-start')
			element.nextElementSibling.classList.add('group-after-end')
		})
	}

	//accordion Functionality
	let acordionitems = document.querySelectorAll('[data-accordion] [data-tab]')
	acordionitems.forEach((item, i) => {
		item.addEventListener('click', function (element) {
			if (!this.classList.contains('active')) {
				acordionitems.forEach((removeactive) => {
					removeactive.classList.remove('active')
					removeactive.nextElementSibling.classList.remove('active')
				})
				this.classList.add('active')
				this.nextElementSibling.classList.add('active')
			} else {
				this.classList.remove('active')
				this.nextElementSibling.classList.remove('active')
			}
		})

		if (i == 0) item.click()
	})

	//Gallery Accordion Functionality
	const allGallerys = document.querySelectorAll('[data-accordiongallery]')

	allGallerys.forEach((gallery, i) => {
		//funcionality accordion
		gallery.addEventListener('click', function (e) {
			if (!this.classList.contains('active')) {
				// allGallerys.forEach((removeactive) => {
				// 	removeactive.classList.remove('active')
				// 	removeactive.nextElementSibling.classList.remove('active')
				// })
				this.classList.add('active')
				this.nextElementSibling.classList.add('active')
			} else {
				this.classList.remove('active')
				this.nextElementSibling.classList.remove('active')
			}
		})

		let galleryTabs= gallery.parentElement.querySelectorAll('[data-imgtab]')
		let galleryItems= gallery.parentElement.querySelectorAll('[data-itemfilter]')
		let gallerySelect= gallery.parentElement.querySelector('[data-galleryselect]')

		//funcionality tabs
		galleryTabs.forEach((item, i) => {
			item.addEventListener('click', function (e) {
				e.preventDefault();
				galleryTabs.forEach(remove => remove.classList.remove('active'));
				this.classList.add('active');
				let selectTab = this.dataset.imgtab;
				galleryItems.forEach(currentItem => {
					currentItem.classList.remove('active')
					if (currentItem.classList.contains(selectTab)) {
						currentItem.classList.add('active')
					}
				});

			})
			//active the first tab		
			if (i == 0) item.click()
		})

		//functionality select
		gallerySelect.addEventListener('change', e => {
			galleryItems.forEach(currentItem => {
				currentItem.classList.remove('active')
				if (currentItem.classList.contains(e.target.value)) {
					currentItem.classList.add('active')
				}
			});
		});
		//active the first accordion
		if (i == 0) gallery.click()
	})
		

	//tabs info Functionality
	const tabsBlock = document.querySelector('.tabs-info')
	if (tabsBlock) {

		let tabsInfo = document.querySelectorAll('[data-tag]')
		let tabsection = document.querySelectorAll('[data-item]')
		let tabselect = document.querySelector('[data-select]')
		
		tabsInfo.forEach((item , i) => {
			item.addEventListener('click',  (e) => {
				tabsInfo.forEach(b => b.classList.remove('active'));
				item.classList.add('active');
				tabsection.forEach(section => {
					section.classList.remove('active');
					if (e.target.dataset.tag=== section.dataset.item ) section.classList.add('active');
				});

			})
			if (i === 0) item.click()
		});

		tabselect.addEventListener('change', e => {
			tabsection.forEach(seccion => {
				seccion.classList.remove('active');
				if (e.target.value === seccion.dataset.item) {
					seccion.classList.add('active');
				}
			});
		});

	}

	//Line Tabs functionality
	const lineTabs = document.querySelectorAll('[data-linetab]')
	if (lineTabs) {
		const lineSection = document.querySelectorAll('[data-lineitem]')
		lineTabs.forEach((item , i) => {

			item.addEventListener('click', (e) => {
				lineTabs.forEach(b => b.classList.remove('active'))
				item.classList.add('active')
				lineSection.forEach(section => {
					section.classList.remove('active')
					if (e.target.dataset.linetab === section.dataset.lineitem) section.classList.add('active')
				});
			})

			if (i === 0) item.click()
		})

	}	

	//email signup animation
	const allInputsSignUp = document.querySelectorAll('.email-signup .input input,.email-signup .select select, .search-form input')
	if (allInputsSignUp) {
		allInputsSignUp.forEach((input) => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved')
			})
		})
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field')

		for (let j = 0; j < allffields.length; j++) {
			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'checkbox' &&
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'radio'
				) {
					allffields[j]
						.getElementsByTagName('input')[0]
						.addEventListener('focus', function () {
							this.parentElement.classList.add('moved')
						})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j]
					.getElementsByTagName('select')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j]
					.getElementsByTagName('textarea')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
		}
	}

	//Signup Cta
	const formSingup = document.querySelector('.footer .email-signup')
	if (formSingup) {
		const element_Wrap = document.querySelector('.footer form .gdpr-wrap')
		const element_Appent = document.querySelector('.signup-btn')
		element_Wrap.insertAdjacentElement('beforeend', element_Appent)
	}

	//Footer Cta Scroll to top
	const footerToTop = document.querySelector('[data-scrolltop]')
	if (footerToTop) {
		footerToTop.addEventListener('click', (e) => {
			e.preventDefault()
			window.scrollTo({top: 0, behavior: 'smooth'})
		})
	}

	//Location Cta
	const locationContent = document.querySelector('[data-location]')
	if (locationContent) {
		const locationCtaopen = document.querySelector('[data-locationopen]')
		const locationCtaclose = document.querySelector('[data-locationclose]')

		locationCtaopen.addEventListener('click', (e) => {
			e.preventDefault()
			locationCtaopen.classList.add('hidden')
			locationContent.classList.add('active')
		})

		locationCtaclose.addEventListener('click', (e) => {
			e.preventDefault()
			locationCtaopen.classList.remove('hidden')
			locationContent.classList.remove('active')
		})
	}

	// table section
	const tablesResp = document.querySelectorAll('[data-table] table');
	if (tablesResp.length) {
			tablesResp.forEach((tablei) => {
					let tableresponsive = document.createElement('div')
					tableresponsive.classList.add('tableHold')
					tablei.parentNode.insertBefore(tableresponsive, tablei)
					tableresponsive.append(tablei)
					const ths = tablei.querySelectorAll('tr:first-child > *')
					tablei.querySelectorAll('tr + tr').forEach((row) => {
							const tds = row.querySelectorAll('td')
							let i = 0
							for (i; i < tds.length; i++) {
									tds[i].setAttribute('data-label', ths[i].textContent)
							}
					})
					const rowHeads = tablei.querySelectorAll('tr td:first-child')
					rowHeads.forEach((ele) => {
							ele.addEventListener('click', (ev) => {
									ele.closest('tr').classList.toggle('active')
							})
					})
			})
	}

	/** Functionality for Dropdown Download CTA **/

	document.addEventListener('DOMContentLoaded', () => {
		const dropdownFirst = document.querySelectorAll('.dropdown-download__first');

		dropdownFirst.forEach((dropdownCTA) => {
			if (dropdownCTA.querySelector('.dropdown-download__submenu')) {
				;['mouseenter', 'mouseleave', 'click'].forEach((event) => {
					dropdownCTA.addEventListener(event, () => {
						dropdownCTA.classList.toggle('hover')
						dropdownCTA.querySelector('.dropdown-download__submenu').classList.toggle('show')
					})
				})
			}
		})


	});
})()

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}

// Weather api
function ApiWeather() {
	const append_Content = document.querySelectorAll('[data-weather-widget]')

	const WEATHER_API_CONF = {
		api_key: '0ddd1af8b5b1833cedd6da7a90934cce',
		unit: 'imperial',
		lat: latitude,
		lon: longitude,
		url: 'https://api.openweathermap.org/data/2.5/weather',
	}

	const url_Fetch = `${WEATHER_API_CONF.url}?&appid=${WEATHER_API_CONF.api_key}&lat=${WEATHER_API_CONF.lat}&lon=${WEATHER_API_CONF.lon}&units=${WEATHER_API_CONF.unit}&appid=${WEATHER_API_CONF.api_key}`

	fetch(url_Fetch)
		.then((response) => response.json())
		.then((data) => {
			const content_Api = `<span class="temp">
														<span class="temp-f">${parseInt(data.main.temp)} °F</span>
														<span class="temp-c">${parseInt((parseInt(data.main.temp) - 32) * 5/9)} °C</span>
													</span>`
			append_Content.forEach((element) => {
				element.innerHTML = content_Api
			})
		})
}

/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold');
let allsublinks = document.querySelectorAll('.sub-menu a');
if(allsublinks.length > 1){
	allsublinks.forEach(ele=>{
		ele.addEventListener('click', function(ev){
			if(ele.classList.contains('active')){
				ev.preventDefault();
			}
		});
	});
	let toggleBtn = document.querySelector('.sub-menu__toggle');
	if(toggleBtn){
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.addEventListener('click', function(){
			toggleBtn.parentElement.classList.toggle('open');
		});
	}
}

// document.addEventListener("DOMContentLoaded", function() {
//   var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

//   if ("IntersectionObserver" in window) {
//     var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(video) {
//         if (video.isIntersecting) {
//           for (var source in video.target.children) {
//             var videoSource = video.target.children[source];
//             if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
//               videoSource.src = videoSource.dataset.src;
//             }
//           }

//           video.target.load();
//           video.target.classList.remove("lazy");
//           lazyVideoObserver.unobserve(video.target);
//         }
//       });
//     });

//     lazyVideos.forEach(function(lazyVideo) {
//       lazyVideoObserver.observe(lazyVideo);
//     });
//   }
// });
